import Vue from 'vue';

Vue.component('product-selector', () =>
    import(/* webpackChunkName: 'selector' */ './product-selector.vue'),
);

Vue.component('multi-outlet-selector', () =>
    import(/* webpackChunkName: 'selector' */ './multi-outlet-selector.vue'),
);

Vue.component('tax-selector', () =>
    import(/* webpackChunkName: 'selector' */ './tax-selector.vue'),
);

Vue.component('stock-selector', () =>
    import(/* webpackChunkName: 'selector' */ './stock-selector.vue'),
);

Vue.component('stock-supplier-selector', () =>
    import(/* webpackChunkName: 'selector' */ './stock-supplier-selector.vue'),
);

Vue.component('inventory-product-selector', () =>
    import(/* webpackChunkName: 'selector' */ './inventory-product-selector.vue'),
);

Vue.component('supplier-selector', () =>
    import(/* webpackChunkName: 'selector' */ './supplier-selector.vue'),
);

Vue.component('distributor-selector', () =>
    import(/* webpackChunkName: 'selector' */ './distributor-selector.vue'),
);

Vue.component('stock-receive-selector', () =>
    import(/* webpackChunkName: 'selector' */ './stock-receive-selector.vue'),
);
